"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralPage = void 0;
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Sky_LifeStyle_Mobile_Icon_02_jpg_1 = __importDefault(require("../assets/WebAssets/Sky Logo/Sky LifeStyle Mobile Icon-02.jpg"));
var referral_1 = require("./referral");
/**
 * Public referral route rendered inside the website's existing HashRouter.
 *
 * The route is deliberately omitted from menus and navigation controls. Users
 * reach it only through a shared referral link or by entering the URL directly.
 */
var ReferralPage = function () {
    var APP_OPEN_DELAY_MS = 7000;
    var APP_OPEN_RESULT_DELAY_MS = APP_OPEN_DELAY_MS + 3000;
    var WEB_REDIRECT_DELAY_MS = 7000;
    var CONTINUE_BUTTON_ENABLE_DELAY_MS = APP_OPEN_DELAY_MS - 3000;
    var MISSING_CODE_REDIRECT_DELAY_MS = 3000;
    var location = (0, react_router_dom_1.useLocation)();
    var _a = (0, react_1.useState)(false), canContinueWithReferral = _a[0], setCanContinueWithReferral = _a[1];
    var _b = (0, react_1.useState)(false), appOpenAttemptFinished = _b[0], setAppOpenAttemptFinished = _b[1];
    var _c = (0, react_1.useState)("idle"), copyStatus = _c[0], setCopyStatus = _c[1];
    var appOpenTimerRef = (0, react_1.useRef)(null);
    var referralCode = (0, referral_1.getReferralCode)(location.search);
    var platform = (0, referral_1.resolvePlatform)(window.navigator.userAgent);
    var mainWebsiteUrl = (0, referral_1.buildMainWebsiteUrl)(window.location.origin);
    var webSignupUrl = referralCode ? (0, referral_1.buildWebSignupUrl)(window.location.origin, referralCode) : mainWebsiteUrl;
    var fallbackUrl = referralCode ? (0, referral_1.resolveFallbackUrl)(platform, referralCode, window.location.origin) : mainWebsiteUrl;
    var appUrl = referralCode ? (0, referral_1.buildAppUrl)(referralCode, window.location.href) : mainWebsiteUrl;
    (0, react_1.useEffect)(function () {
        if (!referralCode) {
            var missingCodeTimer_1 = window.setTimeout(function () {
                window.location.replace(mainWebsiteUrl);
            }, MISSING_CODE_REDIRECT_DELAY_MS);
            return function () { return window.clearTimeout(missingCodeTimer_1); };
        }
        setCanContinueWithReferral(false);
        // Keep the referral design visible for seven seconds on every platform.
        // The visitor can continue manually during the final three seconds.
        var enableContinueButtonTimer = window.setTimeout(function () {
            setCanContinueWithReferral(true);
        }, CONTINUE_BUTTON_ENABLE_DELAY_MS);
        if (platform === "web") {
            var webRedirectTimer_1 = window.setTimeout(function () {
                window.location.replace(webSignupUrl);
            }, WEB_REDIRECT_DELAY_MS);
            return function () {
                window.clearTimeout(enableContinueButtonTimer);
                window.clearTimeout(webRedirectTimer_1);
            };
        }
        setAppOpenAttemptFinished(false);
        appOpenTimerRef.current = window.setTimeout(function () {
            appOpenTimerRef.current = null;
            // Verified Android App Links open the app before this page is loaded.
            // Reaching this timer therefore means the app is not installed, so use
            // the same direct Play URL as the working production referral page.
            window.location.assign(platform === "android" ? fallbackUrl : appUrl);
        }, APP_OPEN_DELAY_MS);
        var appOpenResultTimer = window.setTimeout(function () {
            if (!document.hidden) {
                setAppOpenAttemptFinished(true);
            }
        }, APP_OPEN_RESULT_DELAY_MS);
        var cancelResultTimerWhenAppOpens = function () {
            if (document.hidden) {
                window.clearTimeout(appOpenResultTimer);
            }
        };
        document.addEventListener("visibilitychange", cancelResultTimerWhenAppOpens);
        return function () {
            window.clearTimeout(enableContinueButtonTimer);
            if (appOpenTimerRef.current !== null) {
                window.clearTimeout(appOpenTimerRef.current);
                appOpenTimerRef.current = null;
            }
            window.clearTimeout(appOpenResultTimer);
            document.removeEventListener("visibilitychange", cancelResultTimerWhenAppOpens);
        };
    }, [appUrl, fallbackUrl, mainWebsiteUrl, platform, referralCode, webSignupUrl]);
    var isMissingCode = !referralCode;
    var isMobile = platform !== "web";
    var title = isMissingCode ? "This invitation link is incomplete" : "Your Sky experience is waiting";
    var description = isMissingCode
        ? "No referral code was found. We will take you back to the Sky Lifestyle website."
        : isMobile
            ? "We are opening the Sky Lifestyle app. If it is not installed, use either option below so your referral code is not lost."
            : "We will continue to the Sky Lifestyle signup page with this referral.";
    var status = isMissingCode
        ? "Returning to Sky Lifestyle…"
        : platform === "android"
            ? appOpenAttemptFinished
                ? "The app did not open automatically. Choose an option below."
                : "Opening the app, or Google Play if it is not installed…"
            : platform === "ios"
                ? appOpenAttemptFinished
                    ? "The app did not open automatically. Choose an option below."
                    : "Trying to open the Sky Lifestyle app…"
                : "Opening Sky Lifestyle on the web…";
    var primaryLabel = isMissingCode ? "Visit Sky Lifestyle" : isMobile ? "Open Sky Lifestyle" : "Continue with this referral";
    var primaryUrl = isMissingCode || !isMobile ? webSignupUrl : appUrl;
    var goTo = function (url) {
        if (url === appUrl && appOpenTimerRef.current !== null) {
            window.clearTimeout(appOpenTimerRef.current);
            appOpenTimerRef.current = null;
        }
        window.location.assign(url);
    };
    var copyReferralCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, referralCodeField;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!referralCode) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, window.navigator.clipboard.writeText(referralCode)];
                case 2:
                    _b.sent();
                    setCopyStatus("copied");
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    referralCodeField = document.createElement("textarea");
                    referralCodeField.value = referralCode;
                    referralCodeField.style.position = "fixed";
                    referralCodeField.style.opacity = "0";
                    document.body.appendChild(referralCodeField);
                    try {
                        referralCodeField.select();
                        setCopyStatus(document.execCommand("copy") ? "copied" : "failed");
                    }
                    catch (_c) {
                        setCopyStatus("failed");
                    }
                    finally {
                        document.body.removeChild(referralCodeField);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("main", { className: "relative flex min-h-screen min-w-[320px] items-center justify-center overflow-hidden bg-primary px-4 py-8 md:px-8" },
        react_1.default.createElement("div", { className: "pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-secondary opacity-40", "aria-hidden": "true" }),
        react_1.default.createElement("div", { className: "pointer-events-none absolute -bottom-44 -left-32 h-96 w-96 rounded-full bg-white opacity-10", "aria-hidden": "true" }),
        react_1.default.createElement("div", { className: "relative z-10 flex w-full max-w-[520px] flex-col items-center gap-5" },
            react_1.default.createElement(doshx_controls_web_1.BoxControl, { variant: "filled", backgroundColor: "bg-white", addPadding: false, className: "w-full overflow-hidden rounded-3xl\n          shadow-2xl" },
                react_1.default.createElement("div", { className: "flex items-center gap-4 bg-primary p-5 md:p-6" },
                    react_1.default.createElement("div", { className: "flex h-16 w-16 items-center justify-center overflow-hidden rounded-2xl border-2 border-white bg-white" },
                        react_1.default.createElement(doshx_controls_web_1.LogoControl, { image: Sky_LifeStyle_Mobile_Icon_02_jpg_1.default, size: "xsmall" })),
                    react_1.default.createElement("div", { className: "flex flex-col gap-1" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Sky Lifestyle", textColor: "text-white", size: "medium", bold //
                            : true, uppercase: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Shop smarter. Live better.", textColor: "text-white" //
                            , size: "small" }))),
                react_1.default.createElement("div", { className: "flex flex-col items-center gap-5 p-6 text-center md:p-8" },
                    react_1.default.createElement("div", { className: "flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary text-3xl text-white shadow-md shadow-secondary", "aria-hidden": "true" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGift })),
                    react_1.default.createElement("div", { className: "flex flex-col items-center gap-2" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: isMissingCode ? "Referral link required" : "You have been invited", textColor: "text-secondary", size: "small", bold //
                            : true, uppercase: true }),
                        react_1.default.createElement("h1", { id: "page-title" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "leading-tight", label: title, textColor: "text-primary", size: "3xlarge", center //
                                : true, bold: true })),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "max-w-[390px] leading-6", label: description, textColor: "text-gray-600", size: "small" //
                            , center: true })),
                    !isMissingCode && (react_1.default.createElement(doshx_controls_web_1.BoxControl, { variant: "filled", backgroundColor: "bg-gray-50", addPadding: false, className: "flex w-full items-center justify-between gap-4 border border-gray-200 p-4" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Referral code", textColor: "text-gray-600" //
                            , size: "small" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "max-w-[60%] truncate", label: referralCode, textColor: "text-primary", size: "small" //
                            , bold: true }))),
                    react_1.default.createElement("div", { className: "flex w-full flex-col gap-3", role: "status", "aria-live": "polite" },
                        react_1.default.createElement("div", { className: "flex items-center justify-center gap-2" },
                            !appOpenAttemptFinished && (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "xsmall" //
                                , progressColor: "text-secondary" })),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: status, textColor: "text-gray-600" //
                                , size: "small" })),
                        !appOpenAttemptFinished && (react_1.default.createElement(doshx_controls_web_1.ProgressIndicatorControl, { size: "small", shape: "rounded", barColor: "bg-secondary" //
                            , backgroundColor: "bg-gray-200" }))),
                    !isMissingCode && isMobile && (react_1.default.createElement(doshx_controls_web_1.BoxControl, { variant: "filled", backgroundColor: "bg-gray-50", addPadding: false, className: "flex w-full flex-col gap-3 border border-gray-200 p-4 text-left" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: platform === "ios" ? "Installing on iPhone or iPad?" : "Installing on Android?", textColor: "text-primary", size: "small", bold //
                            : true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Option 1: Copy the referral code, install the app, and paste it into the Referral Code field during signup.", textColor: "text-gray-600", size: "small" //
                         }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Option 2: Install the app, return to this page, then select Open Sky Lifestyle. The app will receive the code from this page.", textColor: "text-gray-600", size: "small" //
                         }),
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: copyStatus === "copied" ? "Referral code copied" : "Copy referral code", backgroundColor: "bg-primary", textColor: "text-white", size: "medium", enabled: copyStatus !== "copied", onClick: function () { return void copyReferralCode(); } }),
                        copyStatus === "failed" && (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "We could not copy automatically. Press and hold the referral code above to copy it.", textColor: "text-secondary", size: "xsmall" //
                         })))),
                    react_1.default.createElement("div", { id: "primary-action", className: "w-full" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: primaryLabel, backgroundColor: "bg-secondary", textColor: "text-white", size: "large" //
                            , enabled: isMissingCode || canContinueWithReferral, onClick: function () { return goTo(primaryUrl); } })),
                    !isMissingCode && isMobile && (react_1.default.createElement("div", { id: "secondary-action", className: "flex justify-center" },
                        react_1.default.createElement(doshx_controls_web_1.AppStoreButtonsControl, { orientation: "horizontal", size: "large", appStore: platform === "ios" ? { onClick: function () { return goTo(fallbackUrl); } } : undefined, playStore: platform === "android" ? { onClick: function () { return goTo(fallbackUrl); } } : undefined }))),
                    !isMissingCode && isMobile && (react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Continue on the website", textColor: "text-primary", decorationColor: "decoration-primary", size: "small", onClick: function () { return goTo(webSignupUrl); } })))),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "One account. More possibilities.", textColor: "text-white", size: "xsmall", uppercase //
                : true, center: true }))));
};
exports.ReferralPage = ReferralPage;
